<template lang="pug">
  - $image_path = '@/assets/images/target/';
  .page-target
    CloseButton
    transition(name="slidein" appear)
      .frame
        h2.frame-maintitle 対象端末
        .frame-textarea
          p.frame-textarea-text.text-break このコンテンツは、iOS11以降、Android 6.0以降での利用を推奨しております。また、以下の機種で動作確認を行っております。

          h3.frame-textarea-subtitle iPhone動作検証端末
          p.frame-textarea-text.text-break iPhone 8 plus、iPhone X、iPhone XS Max、iPhone XR、iPhone11、iPhone Pro

          h3.frame-textarea-subtitle
            | Android動作検証端末（20年4月30日）
            br
            | 対応ブラウザ：Google Chrome
          p.frame-textarea-text.text-indent ・AQUOS R3：OS 9
          p.frame-textarea-text.text-indent ・Xperia 5：OS 9
          p.frame-textarea-text.text-indent ・GALAXY S9：OS 8.0.0
          p.frame-textarea-text.text-indent ・Nexus 5x：OS 8.0.0
          p.frame-textarea-text.text-indent ・Xperia XZ：OS 7.0
          p.frame-textarea-text.text-indent.text-break ・GALAXY S5：OS 6.0.1

          h3.frame-textarea-subtitle PC動作検証環境（PCサイトのみ）
          p.frame-textarea-text.text-indent ・Microsoft Edge 最新版：Windows 10
          p.frame-textarea-text.text-indent ・Firefox 最新版：Windows 10、Mojave
          p.frame-textarea-text.text-indent ・Google Chrome 最新版：Windows 10、Mojave
          p.frame-textarea-text.text-indent.text-break ・Safari 最新版：macOS Mojave

          p.frame-textarea-text.text-break
            | 本リストの機種は、弊社独自に検証した結果を掲載しており、すべての動作を保証するものではありません。
            br
            | 動作確認端末であっても、アプリ経由のゲームプレイ、OSのアップデートや端末の特別な設定等により、動作しなくなる場合があり得ますのでご注意ください。
            br
            | 動作確認端末に記載されていない端末につきましては、動作する可能性もございますが、動作の確認は行っておりません。
            br
            | ご了承くださいますようお願いいたします。

          p.frame-textarea-text また、アプリケーションの動作環境については予告なく変更になる場合がございます。
</template>

<script>
import CloseButton from '@/components/CloseButton';

export default {
  name: 'Target',
  components: {
    CloseButton
  }
};
</script>

<style scoped lang="scss">
.page-target {
  padding: vw(85) 0;
  background: image-url('common/bg_castle.png') no-repeat
    map-get($primary_color, 'grass');
  background-size: 100% auto;
  .frame {
    width: vw(1218);
    height: vw(1762);
    margin: 0 auto;
    background-image: image-url('common/image_frame.png');
    background-size: 100% auto;
  }
}
</style>
